import { render, staticRenderFns } from "./carinfoOwnerLgsList.vue?vue&type=template&id=2a1a66b0"
import script from "./carinfoOwnerLgsList.vue?vue&type=script&lang=js"
export * from "./carinfoOwnerLgsList.vue?vue&type=script&lang=js"
import style0 from "./carinfoOwnerLgsList.vue?vue&type=style&index=0&id=2a1a66b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports